<template>
    <adaptive-modal
        name="email-modal"
        :hide-action-buttons="true"
        width="800"
        @before-open="beforeOpen"
    >
        <!-- eslint-disable vue/no-v-html -->
        <div v-if="email" v-html="email.body" />
        <div v-else>Laddar mail...</div>
    </adaptive-modal>
</template>
<script>
    export default {
        data() {
            return {
                email: null,
            };
        },
        methods: {
            beforeOpen(event) {
                this.email = null;
                axios.get(route('api.emails.show', event.params.id))
                    .then(response => {
                        this.email = response.data;
                    });
            },
        },
    };
</script>